import React from 'react'
import TSelectForm from "../../common/TSelectForm"

const options = [
  {label:'기본', value:'default'},
  {label:'Atom One Dark', value:'atom-one-dark-reasonable'},
  {label:'Atom One Light', value:'atom-one-light'},
  {label:'Github', value:'github'},
  {label:'Monokai', value:'monokai'},
  {label:'Darcula', value:'darcula'},
  {label:'Visual Studio', value:'vs'},
  {label:'Xcode', value:'xcode'},
]


export default function SyntaxHighlightForm(props) {
  const { plugin, data, saveButton, onChange } = props
  const { theme } = data.setting

  function handleSelect(item) {
    onChange({
      setting: {
        theme: item.value
      },
      validated: true
    })
  }

  return (
    <div className="desc_plugin49">
      <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

      <div className="info_plugin">
        <div className="item_set item_sub">
          테마
          <TSelectForm className="opt_set opt_plugin1" items={options} selected={theme} onSelect={handleSelect} />
        </div>
      </div>
      {saveButton()}
    </div>
  )
}
